import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { DocumentNavigationComponent } from 'app/common/components/document-navigation/document-navigation.component';

@Component({
    selector: 'app-order-lost-sale-cell-renderer',
    standalone: true,
    imports: [CommonModule, DecimalPipe, DocumentNavigationComponent],
    template: `
                                                    <app-document-navigation
                                                        [documentType]="'DT002'"
                                                        [documentSerial]="params.data?.serials"
                                                        [displayText]="params.data?.serials"
                                                        [showIcon]="true"
                                                        >
                                                    </app-document-navigation>
  `,
})
export class OrderLostCellRendererComponent implements CellRenderer<any> {
    @Input() params!: CellRendererParams<any>;
}
